module.exports = __webpack_public_path__ + "img/bg.769c6457.png";